var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSortAscending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.0816C10 19.5888 10.4098 20 10.9153 20H21.0847C21.5902 20 22 19.5888 22 19.0816C22 18.5744 21.5902 18.1633 21.0847 18.1633H10.9153C10.4098 18.1633 10 18.5744 10 19.0816ZM10 15C10 15.5072 10.4098 15.9184 10.9153 15.9184H18.0339C18.5394 15.9184 18.9492 15.5072 18.9492 15C18.9492 14.4928 18.5394 14.0816 18.0339 14.0816H10.9153C10.4098 14.0816 10 14.4928 10 15ZM10 10.9184C10 11.4256 10.4098 11.8367 10.9153 11.8367H14.9831C15.4885 11.8367 15.8983 11.4256 15.8983 10.9184C15.8983 10.4112 15.4885 10 14.9831 10H10.9153C10.4098 10 10 10.4112 10 10.9184Z",
    fill: "#565A5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21C6.5098 21 6.92308 20.5925 6.92308 20.0899V6.10732L8.42421 7.58737C8.78469 7.94279 9.36915 7.94279 9.72964 7.58737C10.0901 7.23195 10.0901 6.65569 9.72964 6.30027L6.65271 3.26657C6.29223 2.91115 5.70777 2.91115 5.34729 3.26657L2.27036 6.30027C1.90988 6.65569 1.90988 7.23195 2.27036 7.58737C2.63085 7.94279 3.21531 7.94279 3.57579 7.58737L5.07692 6.10732V20.0899C5.07692 20.5925 5.4902 21 6 21Z",
    fill: "#565A5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortAscending);
export default __webpack_public_path__ + "static/media/ic-sort-ascending.56f8be7b8c954a10c5f8f0695f5b3097.svg";
export { ForwardRef as ReactComponent };